module.exports = __webpack_public_path__ + "img/Icon-LendingTree.2f3855c7.svg";